/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useDispatch } from 'react-redux';

// Material UI
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

// Actions
import { setClose } from 'store/ducks/dialogs/actions';

// Constants
import IMAGES from 'constants/images';

// Styles
import useStyles from './dialogError.styles';

interface DialogErrorInterface {
  title: string;
  message: string;
}

type Props = DialogErrorInterface;

const DialogError: React.FC<Props> = ({ title, message }) => {
  const dispatch = useDispatch();

  const classes = useStyles();

  return (
    <Grid container justifyContent='center' alignItems='center'>
      <Typography variant='h6' className={classes.title}>
        {title}
      </Typography>

      <Grid
        container
        justifyContent='center'
        alignItems='center'
        className={classes.containerReproveIcon}>
        <img src={IMAGES.ICONS.REPROVE_LARGE} alt='reprove' />
      </Grid>

      <Box my={4}>
        <Typography className={classes.subtitle}>{message}</Typography>
      </Box>

      <Button className={classes.button} onClick={() => dispatch(setClose())}>
        Entendi
      </Button>
    </Grid>
  );
};

export default DialogError;
export { DialogError };
